/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var ShieldAltIcon = createIcon({
  name: 'ShieldAltIcon',
  height: 512,
  width: 512,
  svgPath: 'M496 128c0 221.282-135.934 344.645-221.539 380.308a48 48 0 0 1-36.923 0C130.495 463.713 16 326.487 16 128a48 48 0 0 1 29.539-44.308l192-80a48 48 0 0 1 36.923 0l192 80A48 48 0 0 1 496 128zM256 446.313l.066.034c93.735-46.689 172.497-156.308 175.817-307.729L256 65.333v380.98z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default ShieldAltIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/shield-alt-icon.js
// module id = 915
// module chunks = 0